import IconBase from './IconBase'

interface PropsType {
  width?: string | number
  height?: string | number
  className?: string
}

const MinusOIcon = (props: PropsType) => {
  const { width, height, className } = props
  return (
    <IconBase title="icon-minus-o" width={width} height={height} className={className}>
      <path d="M550 50v500H50V50h500m50-50H0v600h600V0z" />
      <path d="M450 275H150v50h300v-50z" />
    </IconBase>
  )
}

export default MinusOIcon
